import StyledLink from '../StyledLink'
import makeQueryString from './makeUrl/makeUrl'
import {
  ASSETS,
  DUPLICATE,
  EDIT,
  GIT_CONNECTIONS,
  SPACES
} from '../routes'

interface Params {
  importTo?: string
}

interface Props {
  children: React.ReactNode
  spaceId: string
  gitConnectionId: string
}

const LinkToDuplicateSpaceAssetsGitConnections = ({
  children,
  spaceId,
  gitConnectionId,
  ...params
}: Props & Params) => {
  const url = `/${SPACES}/${spaceId}/${ASSETS}/${EDIT}/${GIT_CONNECTIONS}/${gitConnectionId}/${DUPLICATE}`

  return (
    <StyledLink to={makeQueryString(url, { ...params })}>
      {children}
    </StyledLink>
  )
}

export default LinkToDuplicateSpaceAssetsGitConnections
